import Q from 'q'
import { createQueryString } from '../util/url'

export const baseUrl = process.env.REACT_APP_API_BASE_URL
export const appVersion = process.env.REACT_APP_VERSION

export const doJson = (url,params={}, raw=false) => {
  const authToken = window.localStorage.getItem('authToken')
  const context = window.localStorage.getItem('webviewContext')
  const query = params.qs ? createQueryString(params.qs) : ''
  const maybeSlash = url[0] === '/' ? '' : '/'
  const urlIsExternal = /^((https?)|(\/\/))/.test(url)

  const endpoint = !urlIsExternal
    ? `${baseUrl}${maybeSlash}${url}${query}`
    : `${url}${query}`

  const paramsWithDefaults = {
    ...params,
    headers:{
      'Authorization': 'Bearer ' + authToken,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-App-Version': appVersion || 'undefined',
      'X-App-Platform': 'web',
      'X-Webview-Context': context || 'undefined',
      'X-Api-Version': '2016-08-01',  // default api version
      ...params.headers
    },
    body: (params.body && (typeof params.body !== 'string'))
      ? JSON.stringify(params.body)
      : undefined
  }

  return Q(fetch(endpoint,paramsWithDefaults))
    .tap((res) => {
      if (!res.ok){
        return res.json().then(err => {
          throw Object.assign(new Error(),err)
        })
      }
    })
    .then(res => {
      return params.raw
        ? res
        : res.text().then(text => text.length ? JSON.parse(text) : null)
    })
}

export const getJson = (url,params) => doJson(url, { method: 'GET', ...params})
export const postJson = (url,params) => doJson(url, { method: 'POST', ...params})
export const putJson = (url,params) => postJson(url, { method: 'PUT', ...params})
export const deleteJson = (url,params) => postJson(url, { method: 'DELETE', ...params})



// WEBPACK FOOTER //
// ./src/api/client.js